import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(() => ({
  container: {
    margin: "0 auto",
    "& .section": {
      borderBottom: "1px solid #F2F2F2",
      marginBottom: "40px",
      margin: "0 auto"
    }
  },
  userOptions: {
    display: "flex",
    flexDirection: "row"
  },
  spaceBottom: {
    paddingBottom: "20px"
  }
}))

export default styles
